import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// import http from "./api/http";

//引入请求类
// Vue.prototype.$net = http;

import Tools from "./utils/tools.js";

import axios from "axios";
Vue.prototype.$axios = axios;

import "./utils/common.css"; // 引入公共css
import "./utils/flex.css"; //flex布局
import "./utils/reset.css"; //重置样式
import "./utils/hover.min.css"; //悬停样式
import "./utils/style.css"; //悬停图片样式

//引入iview
// import iView from "iview";
// import "iview/dist/styles/iview.css";
// Vue.use(iView);

//引入ElementUI
// import ElementUI from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";  //引入样式
// Vue.use(ElementUI);

//部分引入

import {
	Collapse,
	CollapseItem,
	Button,
	Row,
	Col,
	Menu,
	Submenu,
	MenuItem,
	MenuItemGroup,
	Input,
	Message,
	Dialog,
	Carousel,
	CarouselItem,
} from "element-ui";

import CollapseTransition from "element-ui/lib/transitions/collapse-transition";

import "element-ui/lib/theme-chalk/index.css"; //引入样式

Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Button);
Vue.use(Row);
Vue.use(Col);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Input);
Vue.use(Dialog);

Vue.use(Carousel);
Vue.use(CarouselItem);

Vue.component(CollapseTransition.name, CollapseTransition);

// Vue.use(CollapseTransition);

Vue.prototype.$message = Message;

// Vue.use(CollapseTransition);

//引入路由
Vue.use(router);

//引入工具类
Vue.prototype.$Tools = Tools;

//引入swiper
// import VueAwesomeSwiper from "vue-awesome-swiper";
// require styles
// import "swiper/dist/css/swiper.css";
/* { default global options } */
// Vue.use(VueAwesomeSwiper);

//按需加载
// import { Button, Row, Col,Menu, MenuGroup, MenuItem } from "iview";
// Vue.component("Button", Button);
// Vue.component("Row", Row);
// Vue.component("Col", Col);
// Vue.component("Menu", Menu);
// Vue.component("MenuGroup", MenuGroup);
// Vue.component("MenuItem", MenuItem);

Vue.config.productionTip = false;

// 定义全局变量
let appdatadic = {
	ISphone: false,
};

Vue.prototype.$appdata = appdatadic;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
